import { clamp } from "lodash-es";

import {
  HORIZONTAL_SCROLLBAR_HEIGHT,
  MIN_HORIZONTAL_SCROLLBAR_WIDTH,
  MIN_VERTICAL_SCROLLBAR_WIDTH,
  SCROLLBAR_PADDING,
  SCROLLBAR_RADIUS,
  VERTICAL_SCROLLBAR_WIDTH,
} from "../../settings.ts";

function roundedRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
) {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + width, y, x + width, y + height, radius);
  ctx.arcTo(x + width, y + height, x, y + height, radius);
  ctx.arcTo(x, y + height, x, y, radius);
  ctx.arcTo(x, y, x + width, y, radius);
  ctx.closePath();
  ctx.fill();
}

export function drawScrollBars(
  ctx: CanvasRenderingContext2D,
  allTracksHeight: number,
  scrollX: number,
  scrollY: number,
  maxWidth: number,
  originOffset: number,
  hoveringHorizontalScrollbar: boolean,
  hoveringVerticalScrollbar: boolean,
) {
  const width = ctx.canvas.width;
  const height = ctx.canvas.height;

  // Scrollbar style
  ctx.fillStyle = hoveringVerticalScrollbar ? "rgba(0, 0, 0, 0.65)" : "rgba(0, 0, 0, 0.45)";

  // Only draw vertical scrollbar if content height exceeds viewport height
  if (allTracksHeight > height) {
    const verticalBarHeight = Math.max(
      MIN_VERTICAL_SCROLLBAR_WIDTH,
      Math.min(height - 2 * SCROLLBAR_PADDING, (height / allTracksHeight) * height),
    );
    const verticalBarY =
      SCROLLBAR_PADDING +
      (scrollY / Math.max(allTracksHeight - height, 1)) * (height - 2 * SCROLLBAR_PADDING - verticalBarHeight);

    roundedRect(
      ctx,
      width - VERTICAL_SCROLLBAR_WIDTH - 2,
      verticalBarY,
      VERTICAL_SCROLLBAR_WIDTH,
      verticalBarHeight,
      SCROLLBAR_RADIUS,
    );
  }

  if (maxWidth > width) {
    ctx.fillStyle = hoveringHorizontalScrollbar ? "rgba(0, 0, 0, 0.65)" : "rgba(0, 0, 0, 0.45)";

    const scaleX = width / maxWidth;
    // Draw horizontal scroll bar
    const horizontalBarWidth = clamp(width * scaleX, MIN_HORIZONTAL_SCROLLBAR_WIDTH, width - 2 * SCROLLBAR_PADDING);
    const horizontalBarX = clamp(
      SCROLLBAR_PADDING + (scrollX - originOffset) * scaleX,
      1,
      width - 2 * SCROLLBAR_PADDING - horizontalBarWidth,
    );
    roundedRect(
      ctx,
      horizontalBarX,
      height - HORIZONTAL_SCROLLBAR_HEIGHT - 2,
      horizontalBarWidth,
      HORIZONTAL_SCROLLBAR_HEIGHT,
      SCROLLBAR_RADIUS,
    );
  }
}
